import { Col, ColType, Crud } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";
import '../clientConfig/index.scss'
import { ProductStatus } from "../../comp/cell";

let apiClient = ApiClient.getDefault();
let cols: Col[] = [

    {
        name: "名称",
        key: "name",
        width: 200,
        type: ColType.STRING
    },
    {
        name: "房产",
        key: "ext.house",
        width: 100,
        optional: true,
        type: ColType.STRING

    },
    {
        name: "公司",
        optional: true,
        width: 100,
        key: "ext.company",
        type: ColType.STRING
    },
    {
        name: "信用",
        optional: true,
        width: 500,
        key: "ext.credit",
        type: ColType.STRING
    },
    {
        name: "工作",
        optional: true,
        width: 100,
        key: "ext.job",
        type: ColType.STRING
    },
    {
        name: "收入",
        optional: true,
        width: 100,
        key: "ext.income",
        type: ColType.STRING
    },
    {
        name: "还款方式",
        optional: true,
        key: "ext.repayment",
        width: 100,
        type: ColType.STRING
    },
    {
        name: "利率",
        optional: true,
        key: "ext.interest",
        width: 100,
        type: ColType.STRING
    },
    {
        name: "期限",
        optional: true,
        width: 100,
        key: "ext.term",
        type: ColType.STRING
    }
]
export default function Product() {
    return <Crud
        canUpdate={true}
        canCreate={true}
        name="产品"
        entityKey="products"
        pageSize={50}
        cols={cols}
        bordered={true}

    />
}